import { MenuItem, Box } from "@mui/material";
import Select from "@mui/material/Select";
import { ReactComponent as SelectArrowIcon } from "../../assets/icons/selectArrow.svg";

const FormSelect = ({
  label,
  error,
  helperText,
  menuItems,
  disabled,
  value,
  onChange,
  name,
  ...props
}) => {
  // Ensures value is never undefined
  const selectValue = value || "";

  return (
    <Box style={{
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: 1,
      display: 'inline-flex',
      position: 'relative',
      paddingBottom: 5
    }}>
      <Box style={{
        alignSelf: 'stretch',
        marginBottom: 0
      }}>
        <div style={{
          color: disabled ? "#B7B6B6" : '#1A1A1A',
          fontSize: 12,
          fontFamily: 'Helvetica Neue LT Std',
          fontWeight: '400',
          textTransform: 'capitalize',
          lineHeight: '16px',
          letterSpacing: 0.70,
          wordWrap: 'break-word',
          position: 'absolute',
          top: -7.5,
          left: 10,
          background: disabled ? "transparent" : "white",
          paddingLeft: "3px",
          paddingRight: "3px",
          display: "block",
          zIndex: 100,
        }}>
          {label}
        </div>
      </Box>
      <Box style={{
        alignSelf: 'stretch',
        height: 38,
        paddingLeft: 12,
        paddingRight: 12,
        borderRadius: 4,
        border: '1px #012A52 solid',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        display: 'flex'
      }}>
        <Box style={{
          height: 38,
          width: "100%",
          alignSelf: 'stretch',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
          display: 'inline-flex',
          position: 'absolute',
          zIndex: 0,
          left: 0,
        }}>
          <Select
            value={!disabled ? selectValue : null}
            onChange={onChange}
            name={name}
            error={error}
            disabled={disabled}
            style={{ border: "none", width: "100%", height: "108%", marginTop: "1px", boxShadow: "none", color: 'black', opacity: disabled ? 0.8 : 1.0, backgroundColor: disabled ? "#f0f0f0" : "transparent"}}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 400,
                },
              }
            }}
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            }}
            IconComponent={!disabled ? SelectArrowIcon : () => <></>}
            {...props}
          >
            {menuItems.map((item) => (
              <MenuItem value={item}>{item}</MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
      {error && <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>{helperText}</div>}

    </Box>
  )
}

export default FormSelect;